// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable } from 'mobx';
import { cloneDeep, isNil, get } from 'lodash/fp';
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';

const {FORMAT_TYPE} = constants;

class ConditionalFormattingFormat{
  @observable type = {
    title: '',
    value: ''
  };
  @observable value = null;

  constructor(format){
    if(format){
      this.parseData(format);
    }

    this.setDefaultFormatValueIfEmpty();
  }

  setFormatType(type){
    this.type = {
      value: type.value,
      title: type.label
    };
    this.value = null;

    this.setDefaultFormatValueIfEmpty();
  }

  parseData(format){
    format = cloneDeep(format);
    this.type = format.type;
    this.value = format.value;
  }

  setDefaultFormatValueIfEmpty(){
    const type = this.type.value;
    const value = this.value;

    if(type === FORMAT_TYPE.FONT_FORMAT.value){
      const fontFamily = get('font.fontFamily', value);
      const fontSize = get('font.fontSize', value);
      const fontBold = get('style.fontBold', value) ? true : false;
      const fontItalic = get('style.fontItalic', value) ? true : false;
      const fontUnderline = get('style.fontUnderline', value) ? true : false;

      this.value = {
        font: {
          fontFamily: isNil(fontFamily) ? 'Roboto' : fontFamily,
          fontSize: isNil(fontSize) ? 14 : fontSize,
        },
        style: {
          fontBold: fontBold,
          fontItalic: fontItalic,
          fontUnderline: fontUnderline
        }
      }
    }else {
      if(!isNil(value))
        return;

      switch(type){
        case FORMAT_TYPE.FONT_COLOR.value:
          this.value = '#000';
          break;
        case FORMAT_TYPE.BACKGROUND_COLOR.value:
          this.value = '#fff';
          break;
      }
    }
  }

  serializeData(){
    const {type, value} = this;
    return{
      type,
      value
    };
  }
}

export default ConditionalFormattingFormat;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingFormat.js